import React from 'react';
import SvgPositionedElement from '../SvgPositionedElement/SvgPositionedElement';
import './WatermarkManager.css';

/**
 * Renders the main and hands watermarks; SvgPositionedElement switches them to
 * absolute below the lg breakpoint and fades them on scroll.
 */
const WatermarkManager: React.FC = () => {
    return (
        <>
            <SvgPositionedElement
                svgPath="/ys.svg"
                fixed={true}
                className="watermark-container watermark-main"
                useThemeColors={true}
                fadeTarget=".title-tagline"
                data-testid="svg-watermark-main-watermark"
            />
            <SvgPositionedElement
                svgPath="/hands.svg"
                fixed={true}
                className="watermark-container watermark-hands"
                useThemeColors={true}
                fadeTarget=".title-tagline"
                data-testid="svg-watermark-hands-watermark"
            />
        </>
    );
};

export default WatermarkManager;